<template>
    <div id="payment-type-options">
        <button class="google-pay-button pay-button">
            <div id="googlepay-mark" class="sprite google-pay-light disabled-image" />
        </button>
        <button id="nspay-apple-pay" class="apple-pay-button no-apple-pay">
            <div class="apple-pay-button-container disabled-image">
                <div id="apple-pay-logo"></div>
            </div>
        </button>
        <div id="i4goFrame" />
        <form id="form-main">
            <input id="i4go_response" name="i4go_response" type="hidden" />
            <input id="i4go_responsecode" name="i4go_responsecode" type="hidden" />
            <input id="i4go_responsetext" name="i4go_responsetext" type="hidden" />
            <input id="i4go_cardtype" name="i4go_cardtype" type="hidden" />
            <input id="i4go_maskedcard" name="i4go_maskedcard" type="hidden" />
            <input id="i4go_uniqueid" name="i4go_uniqueid" type="hidden" />
            <input id="i4go_expirationmonth" name="i4go_expirationmonth" type="hidden" />
            <input id="i4go_expirationyear" name="i4go_expirationyear" type="hidden" />
            <input id="i4go_cardholdername" name="i4go_cardholdername" type="hidden" />
            <input id="i4go_streetaddress" name="i4go_streetaddress" type="hidden" />
            <input id="i4go_postalcode" name="i4go_postalcode" type="hidden" />
            <input id="i4go_extendedcarddata" name="i4go_extendedcarddata" type="hidden" />
            <input id="i4go_utoken" name="i4go_utoken" type="hidden" />
            <input id="i4go_googlepaytoken" name="i4go_googlepaytoken" type="hidden" />
            <input id="i4go_applepaytoken" name="i4go_applepaytoken" type="hidden" />
            <input id="i4go_signeddata" name="i4go_signeddata" type="hidden" />
        </form>
    </div>
</template>
<script>
    require("@/scripts/jquery.i4goTrueToken-wallets.js");
    require("@/scripts/jquery.cardswipe.js");

    import $ from "jquery";
    import axios from "axios";
    import { mapGetters, mapState, mapMutations } from "vuex";
    import { paymentMethods } from "../../../constants/payment-methods";
    import { showBlocker } from "../../../mixins/show-blocker";
    import { appSettings } from "../../../mixins/app-settings";

    export default {
        name: "Shift4ApplePayGooglePay",
        mixins: [showBlocker, appSettings],
        data() {
            return {
                initialized: false
            }
        },
        computed: {
            ...mapState({
                siteId: state => state.session.siteId,
                accountId: state => state.session.accountId,
                checkId: state => state.session.checkId,
                tip: state => state.session.tip,
                googlePayScriptLoaded: state => state.session.googlePayScriptLoaded
            }),
            ...mapGetters([
                "balanceWithTip"
            ])
        },
        watch: {
            googlePayScriptLoaded: "initialize"
        },
        methods: {
            ...mapMutations([
                "setLoadingStatus",
                "setPayment"
            ]),
            async setupWallets() {
                // Initialize Google Pay and Apple Pay.

                const authorizeUrl = this.getApiBaseUrl() + "/shift4/authorizeclient/" + this.accountId + "/" + this.siteId + "/" + this.balanceWithTip;
                let authorizationData;

                await axios.get(authorizeUrl)
                    .then(response => {
                        if (response.data) {
                            authorizationData = response.data;
                        }
                        else {
                            this.$router.push({ name: "Error", params: { errorCode: "1027" } });
                            return;
                        }
                    })
                    .catch(error => {
                        console.error("Error authorizing client - " + error);

                        if (error.response &&
                            error.response.data &&
                            error.response.data.errorCode) {
                            this.$router.push({ name: "Error", params: { errorCode: error.response.data.errorCode } });
                        }
                        else {
                            this.$router.push({ name: "Error", params: { errorCode: "1027" } });
                        }

                        return;
                    });

                var that = this;

                $("#form-main").i4goTrueToken({
                    debug: true,
                    url: authorizationData.i4mUrl,
                    server: authorizationData.server,
                    accessBlock: authorizationData.accessBlock,
                    self: document.location,
                    template: "bootstrap4",
                    language: "en",
                    submitButton: { label: "Submit payment", visible: true },
                    encryptedOnlySwipe: false,
                    wallet: {
                        buttonColor: "white",
                        buttonType: "plain",
                        paymentInitiatedEvent: function () {
                            that.showBlockerWithSpinner();
                        },
                        paymentErrorEvent: function (error) {
                            that.stopProgressIndicator();
                            console.error(error);

                            // A "cancel" is considered an error. For anything other than a "cancel", it's
                            // an unknown error condition that we have to handle.
                            if (error !== undefined && error.statusCode !== "CANCELED") {
                                this.$router.push({ name: "Error", params: { errorCode: "1016" } });
                            }
                        }
                        // Note: paymentInitiatedEvent and paymentErrorEvent are CBS added wallet settings to block
                        // the UI while Google Pay is in progress and unblock the UI when there's an error or when the
                        // user exits the Google Pay dialog.
                    },
                    onSuccess: () => {
                        console.log("Credit card payment initialization succeeded!");
                        this.sendPayloadToServer();
                    },
                    onFailure: () => {
                        console.warn("Credit card payment initialization failed!");
                    }
                });
            },
            sendPayloadToServer() {
                console.log("Started processing payment..");

                let oePayload =
                {
                    SiteId: this.siteId,
                    AccountId: this.accountId,
                    CheckId: this.checkId,
                    PaymentAmount: this.balanceWithTip,
                    TipAmount: this.tip,
                    PaymentNonce: $("#i4go_uniqueid").val(),
                    ExtendedCardData: $("#i4go_extendedcarddata").val()
                }

                this.startProgressIndicator();

                axios.post(this.getApiBaseUrl() + "/payment/payment", oePayload)
                    .then(response => {
                        if (response.data) {
                            let payment = response.data;
                            payment.paymentName = paymentMethods.googlePay;
                            this.setPayment(payment);
                            this.$router.push({ name: "PaymentSummary" });
                        }
                        else {
                            this.$router.push({ name: "Error", params: { errorCode: "1010" } });
                        }
                    })
                    .catch(error => {
                        if (error.response &&
                            error.response.data &&
                            error.response.data.errorCode) {
                            switch (error.response.data.errorCode) {
                                case "1008":
                                case "1009":
                                case "1025":
                                    this.$router.push({ name: "Error", params: { errorCode: error.response.data.errorCode } });
                                    break;
                                default:
                                    if (error.response.data.errorMessage) {
                                        console.error(error.response.data.errorMessage);
                                    }
                                    this.$router.push({ name: "Error", params: { errorCode: "1010" } });
                            }
                        }
                        else {
                            console.error(error);
                            this.$router.push({ name: "Error", params: { errorCode: "1010" } });
                        }
                    })
                    .finally(() => {
                        this.stopProgressIndicator();
                    });
            },
            async initialize() {
                if (!this.initialized && this.googlePayScriptLoaded)
                {
                    this.initialized = true;
                    await this.setupWallets();
                }                    
            }
        },        
        async mounted() {
            await this.initialize();
        }
    }
</script>

<style scoped>
    #i4goFrame {
        visibility: hidden;
    }

    .disabled-image {
        opacity: 0.5;
    }

    #nspay-apple-pay {
        margin-top: 12px;
    }

    #apple-pay-logo {
        min-height: 30px;
    }

    .apple-pay-button {
        padding: 0;
    }

    .no-apple-pay {
        visibility: hidden;
    }

</style>